export const DEFAULT_DURATION = 500;
export const GLOBAL_OFFSET_ELEMENTS_SELECTORS = [
  `.sticky-header-wrapper`
];
